export default __webpack_public_path__ + "static/media/aerial-test-2.38565d6e.webp";